export const API_BASE_URL = 'https://api.openweathermap.org/data/2.5/weather'
export const API_KEY = 'e295453c3f7e9be0c8078637a5c099d3'
